import { render, staticRenderFns } from "./FloatingNavigateBack.vue?vue&type=template&id=63deed88&"
import script from "./FloatingNavigateBack.vue?vue&type=script&lang=ts&"
export * from "./FloatingNavigateBack.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports